import { createSlice } from "@reduxjs/toolkit";

const alertSlice = createSlice({
  name: "alert",
  initialState: false,
  reducers: {
    openAlert: () => true,
    closeAlert: () => false,
    toggleAlert: (state) => !state,
  },
});

export const { openAlert, closeAlert, toggleAlert } =
  alertSlice.actions;

export default alertSlice.reducer;
